module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "area clear"
  }, [_c('div', {
    attrs: {
      "id": "province"
    }
  }, [_c('selecter', {
    attrs: {
      "selectData": _vm.provinces,
      "autoIsShow": false,
      "selectObj": "province",
      "selecterText": _vm.province_text
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "city"
    }
  }, [_c('selecter', {
    attrs: {
      "selectData": _vm.cities,
      "autoIsShow": false,
      "selectObj": "city",
      "selecterText": _vm.city_text
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "district"
    }
  }, [_c('selecter', {
    attrs: {
      "selectData": _vm.districts,
      "autoIsShow": false,
      "selectObj": "district",
      "selecterText": _vm.district_text
    },
    on: {
      "selecter": _vm.selecter
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b24d348","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkArea/checkArea.vue
// module id = 1214
// module chunks = 1